import { useNavigate, useLocation } from "react-router-dom";

import ForYouIcon from "../icons/ForYou";
import TenderIcon from "../icons/Tender";
import UserIcon from "../icons/User";
import SaveIcon from "../icons/Save";
import SavedCount from "../SavedCount";

const tabs = [
  {
    to: "/latest-tenders/telegram",
    match: "/latest-tenders/telegram",
    label: "Tenders",
    Icon: TenderIcon,
  },
  {
    to: "/myfeed/telegram",
    match: "/myfeed/telegram",
    label: "For You",
    Icon: ForYouIcon,
  },
  {
    to: "/saved/telegram",
    match: "/saved/telegram",
    label: "Saved",
    Icon: SaveIcon,
    badge: true,
  },
  {
    to: "/account/telegram",
    match: "/account/telegram",
    label: "Account",
    Icon: UserIcon,
  },
];

const TelegramBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeIndex = tabs.findIndex((tab) =>
    location.pathname.startsWith(tab.match)
  );

  const iconStyles = (active) =>
    `w-6 h-6 transition-all duration-300 ${
      active ? "fill-[#664bc7]/25" : "fill-transparent"
    }`;

  return (
    <nav className="fixed bottom-4 inset-x-4 z-50 flex justify-center pointer-events-none">
      <div
        className="pointer-events-auto w-full max-w-[420px] p-1.5
        rounded-full bg-white/70 backdrop-blur-xl backdrop-saturate-150
        border border-white/60 shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        ring-1 ring-black/5"
      >
        <div className="relative flex w-full">
          <span
            aria-hidden="true"
            className="absolute inset-y-0 left-0 w-1/4 rounded-full bg-gray-500/10"
            style={{
              transform: `translateX(${Math.max(activeIndex, 0) * 100}%)`,
              opacity: activeIndex < 0 ? 0 : 1,
              transition:
                "transform 450ms cubic-bezier(0.34, 1.4, 0.64, 1), opacity 200ms ease",
            }}
          />

          {tabs.map((tab, index) => {
            const active = index === activeIndex;
            const Icon = tab.Icon;
            return (
              <button
                key={tab.to}
                onClick={() => navigate(tab.to)}
                className={`relative z-10 flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-colors duration-300 ${
                  active
                    ? "text-[#664bc7] font-semibold"
                    : "text-[#664bc7]/70"
                }`}
              >
                {tab.badge ? (
                  <div className="relative">
                    <SavedCount />
                    <Icon styles={iconStyles(active)} />
                  </div>
                ) : (
                  <Icon styles={iconStyles(active)} />
                )}
                <span className="text-[11px] leading-none">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default TelegramBottomNav;
